// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Small devices (phones, 320px to 480px) */
@media (min-width: 320px) and (max-width: 480px) {

  *,
  *::before,
  *::after {
    outline: none !important;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  :root {
    --Awesome: "FontAwesome", sans-serif;
  }

  .existing-courselist {

    box-sizing: border-box;
  }

  .existing-courselist h6 {
    margin-bottom: 0.5rem;
  }

  .more-menu-listing {
    right: 4rem;
  }

  .goi-logo {
    width: 100%;
  }

  .goi-logo li:first-child {
    text-align: left;
  }

  .goi-logo li:last-child {
    border-left: none;
    padding-inline: 0;
    margin-inline: 0;
  }

  .lms-mascotbg {
    display: none;
  }

  .h100percent {
    height: 0;
  }

  .login-bg {
    padding: 1rem;
    margin-left: .75rem !important;
  }

  .my-innermenu {
    width: 100%;
    flex-direction: row;
    margin-left: 0 !important;
    justify-content: space-between;
  }

  .navbar-nav .dropdown-menu {
    position: absolute;
  }

  #mylearnign-info {
    right: auto;
  }

  .h304 {
    height: 100%;
  }

  .new-coursebtn {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
  }

  .search-icon::before {
    display: none;
  }

  .video-listing-bg {
    margin-bottom: 4rem;
  }

  .hero-slider {
    width: 100%;
    padding: 0;

  }

  .hero-slider-img,
  .slider {
    height: auto;
  }

  .count-stats {
    position: initial;
    width: 100%;
    border-radius: 0;
  }

  .count-list {
    gap: inherit;
    flex-wrap: wrap;
    align-items: baseline;
  }

  .count-list li {
    flex: 1;
  }

  .footer-links {
    flex-wrap: wrap;
  }

  .about-lms {
    margin-top: 0;
    padding: 0;
  }

  .about-imgbox {
    text-align: center;
    display: none;
  }

  .learners-tabsinfo {
    display: flex;
    gap: inherit;
    flex-wrap: nowrap;
  }

  .learners-tabsinfo li {
    flex: 1;
    font-size: 12px;
    white-space: nowrap;
  }

  .courses-tabcontainer {
    flex-wrap: nowrap;
  }

  .courses-tabcontainer .nav-link {
    font-size: 0.85rem;
  }

  #courselist {
    display: none;
  }

  .courses-tabcontainer {
    justify-content: flex-start;
    overflow-x: scroll;
    overflow-y: hidden;
  }

  .courses-tabcontainer li:first-child {
    display: block;
  }

  .summary-container {
    padding-bottom: 2rem;
    text-align: center;
  }

  .count-card-container {
    margin-bottom: 1rem;
  }

  .search-videosbar {
    width: 97%;
    top: .25rem;
    left: 1rem;
    /* z-index: 1000; */
    margin: 0 auto;
  }

  .navbar-toggler {
    background-color: #fff;
  }

  .text-end {
    /* text-align: initial !important; */
  }

  .btn-outline-dark {
    margin-bottom: 1rem;
  }

  .approve-course-heading {
    margin-bottom: 1rem;
  }

  .approve-course-container {
    height: auto;
    margin-bottom: inherit;
  }

  .v-line {
    display: none !important;
  }

  .count-card-container {
    margin-block: 1rem;
  }

  .count-list li .count {
    font-size: 1.25rem;
  }

  .online-user-circle {
    position: relative;
    top: 3px;
  }

  .count-list li .icon {
    width: 3.5rem;
    height: 3.5rem;
  }

  .about-headingtxt {
    display: block;
    font-weight: 700;
  }

  .top-navbar .nav-link {
    justify-content: flex-start;
  }

  .navbar-toggler-icon {
    width: 1.1em;
    height: 1.1em;
  }

  .oneline-usertxt {
    display: none;
  }

  .mobile-links {
    display: inline-flex;
    padding-inline: 1rem;
    gap: 1rem;
  }

  .web-login-links {
    display: none;
  }

  .learners-tabsinfo {
    justify-content: left;
  }

  .course-card {
    margin-bottom: 0.5rem;
  }

  .course-thumbnail:hover::before,
  .course-thumbnail:hover::after {
    background-color: transparent;
  }

  .question-list-container {
    padding: 0 !important;
  }

  .left-menu-panel {
    min-height: auto;
  }

  .show-menu,
  .hide-menu {
    width: auto;
  }

  .show-menu i,
  .hide-menu i {
    font-size: 1.25rem;
    padding: 0.25rem 0.75rem;
  }

  .hide-menu {
    left: 90%;
  }
  .react-bootstrap-table table {
    table-layout: auto;
}
.form-check {
  display: ruby;
}
.footer-bottom-link {
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;
}
.footer-bottom-link small:nth-child(1){   
    border-right: 0px;
}
.slide-in-container {
  max-width: 100%;
}
}

/* Medium devices (phones to small tablets, 481px to 767px) */
@media (min-width: 481px) and (max-width: 767px) {
  .add-video-container {
    padding: 16px 8px;
  }

  .lms-heading {
    font-size: 0.875rem !important;
  }

  .navbar-toggler-icon {
    width: 1.25em;
    height: 1.25em;
  }

  .learners-tabsinfo {
    justify-content: left;
  }
}

/* Large tablets (768px to 1024px) */
@media (min-width: 768px) and (max-width: 1024px) {
  .course-desc-box {
    margin-top: 3rem;
  }

  .count-list {
    gap: inherit;
  }

  .navbar-toggler {
    background-color: #fff;
  }

  .lms-mascotbg {
    order: 1;
  }

  .goi-logo li:first-child {
    text-align: left;
  }

  .goi-logo li:last-child {
    border: none;
    padding-inline: inherit;
    margin-inline: inherit;
  }

  .about-imgbox {
    text-align: center;
  }

  .my-innermenu {
    flex-direction: row;
  }

  .learners-tabsinfo {
    gap: 0;
  }

  .navbar-nav .dropdown-menu {
    position: absolute;
    left: -3.75rem;
  }
}

/* Small desktops (1025px to 1200px) */
@media (min-width: 1025px) and (max-width: 1200px) {
  .about-headingtxt {
    display: none;
  }
}

/* Large desktops (1201px and up) */
@media (min-width: 1201px) {
  .about-headingtxt {
    display: none;
  }
}
@media (max-width: 767px) {
.course-listing:hover,
  .course-listing-learner:hover {
    position: static !important;
    width: 100% !important;
    box-shadow: none !important;
    z-index: auto !important;
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/responsive.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;;EAEE;;;IAGE,wBAAwB;IACxB,UAAU;IACV,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;;EAEZ;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,OAAO;IACP,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;AAEA,6DAA6D;AAC7D;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,aAAa;EACf;AACF;AACA;AACA;;IAEI,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;EAC7B;AACF","sourcesContent":["/* Small devices (phones, 320px to 480px) */\n@media (min-width: 320px) and (max-width: 480px) {\n\n  *,\n  *::before,\n  *::after {\n    outline: none !important;\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n  }\n\n  :root {\n    --Awesome: \"FontAwesome\", sans-serif;\n  }\n\n  .existing-courselist {\n\n    box-sizing: border-box;\n  }\n\n  .existing-courselist h6 {\n    margin-bottom: 0.5rem;\n  }\n\n  .more-menu-listing {\n    right: 4rem;\n  }\n\n  .goi-logo {\n    width: 100%;\n  }\n\n  .goi-logo li:first-child {\n    text-align: left;\n  }\n\n  .goi-logo li:last-child {\n    border-left: none;\n    padding-inline: 0;\n    margin-inline: 0;\n  }\n\n  .lms-mascotbg {\n    display: none;\n  }\n\n  .h100percent {\n    height: 0;\n  }\n\n  .login-bg {\n    padding: 1rem;\n    margin-left: .75rem !important;\n  }\n\n  .my-innermenu {\n    width: 100%;\n    flex-direction: row;\n    margin-left: 0 !important;\n    justify-content: space-between;\n  }\n\n  .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  #mylearnign-info {\n    right: auto;\n  }\n\n  .h304 {\n    height: 100%;\n  }\n\n  .new-coursebtn {\n    position: relative;\n    top: auto;\n    left: auto;\n    transform: none;\n  }\n\n  .search-icon::before {\n    display: none;\n  }\n\n  .video-listing-bg {\n    margin-bottom: 4rem;\n  }\n\n  .hero-slider {\n    width: 100%;\n    padding: 0;\n\n  }\n\n  .hero-slider-img,\n  .slider {\n    height: auto;\n  }\n\n  .count-stats {\n    position: initial;\n    width: 100%;\n    border-radius: 0;\n  }\n\n  .count-list {\n    gap: inherit;\n    flex-wrap: wrap;\n    align-items: baseline;\n  }\n\n  .count-list li {\n    flex: 1;\n  }\n\n  .footer-links {\n    flex-wrap: wrap;\n  }\n\n  .about-lms {\n    margin-top: 0;\n    padding: 0;\n  }\n\n  .about-imgbox {\n    text-align: center;\n    display: none;\n  }\n\n  .learners-tabsinfo {\n    display: flex;\n    gap: inherit;\n    flex-wrap: nowrap;\n  }\n\n  .learners-tabsinfo li {\n    flex: 1;\n    font-size: 12px;\n    white-space: nowrap;\n  }\n\n  .courses-tabcontainer {\n    flex-wrap: nowrap;\n  }\n\n  .courses-tabcontainer .nav-link {\n    font-size: 0.85rem;\n  }\n\n  #courselist {\n    display: none;\n  }\n\n  .courses-tabcontainer {\n    justify-content: flex-start;\n    overflow-x: scroll;\n    overflow-y: hidden;\n  }\n\n  .courses-tabcontainer li:first-child {\n    display: block;\n  }\n\n  .summary-container {\n    padding-bottom: 2rem;\n    text-align: center;\n  }\n\n  .count-card-container {\n    margin-bottom: 1rem;\n  }\n\n  .search-videosbar {\n    width: 97%;\n    top: .25rem;\n    left: 1rem;\n    /* z-index: 1000; */\n    margin: 0 auto;\n  }\n\n  .navbar-toggler {\n    background-color: #fff;\n  }\n\n  .text-end {\n    /* text-align: initial !important; */\n  }\n\n  .btn-outline-dark {\n    margin-bottom: 1rem;\n  }\n\n  .approve-course-heading {\n    margin-bottom: 1rem;\n  }\n\n  .approve-course-container {\n    height: auto;\n    margin-bottom: inherit;\n  }\n\n  .v-line {\n    display: none !important;\n  }\n\n  .count-card-container {\n    margin-block: 1rem;\n  }\n\n  .count-list li .count {\n    font-size: 1.25rem;\n  }\n\n  .online-user-circle {\n    position: relative;\n    top: 3px;\n  }\n\n  .count-list li .icon {\n    width: 3.5rem;\n    height: 3.5rem;\n  }\n\n  .about-headingtxt {\n    display: block;\n    font-weight: 700;\n  }\n\n  .top-navbar .nav-link {\n    justify-content: flex-start;\n  }\n\n  .navbar-toggler-icon {\n    width: 1.1em;\n    height: 1.1em;\n  }\n\n  .oneline-usertxt {\n    display: none;\n  }\n\n  .mobile-links {\n    display: inline-flex;\n    padding-inline: 1rem;\n    gap: 1rem;\n  }\n\n  .web-login-links {\n    display: none;\n  }\n\n  .learners-tabsinfo {\n    justify-content: left;\n  }\n\n  .course-card {\n    margin-bottom: 0.5rem;\n  }\n\n  .course-thumbnail:hover::before,\n  .course-thumbnail:hover::after {\n    background-color: transparent;\n  }\n\n  .question-list-container {\n    padding: 0 !important;\n  }\n\n  .left-menu-panel {\n    min-height: auto;\n  }\n\n  .show-menu,\n  .hide-menu {\n    width: auto;\n  }\n\n  .show-menu i,\n  .hide-menu i {\n    font-size: 1.25rem;\n    padding: 0.25rem 0.75rem;\n  }\n\n  .hide-menu {\n    left: 90%;\n  }\n  .react-bootstrap-table table {\n    table-layout: auto;\n}\n.form-check {\n  display: ruby;\n}\n.footer-bottom-link {\n  flex-direction: column;\n  gap: 1rem;\n  padding-bottom: 1rem;\n}\n.footer-bottom-link small:nth-child(1){   \n    border-right: 0px;\n}\n.slide-in-container {\n  max-width: 100%;\n}\n}\n\n/* Medium devices (phones to small tablets, 481px to 767px) */\n@media (min-width: 481px) and (max-width: 767px) {\n  .add-video-container {\n    padding: 16px 8px;\n  }\n\n  .lms-heading {\n    font-size: 0.875rem !important;\n  }\n\n  .navbar-toggler-icon {\n    width: 1.25em;\n    height: 1.25em;\n  }\n\n  .learners-tabsinfo {\n    justify-content: left;\n  }\n}\n\n/* Large tablets (768px to 1024px) */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .course-desc-box {\n    margin-top: 3rem;\n  }\n\n  .count-list {\n    gap: inherit;\n  }\n\n  .navbar-toggler {\n    background-color: #fff;\n  }\n\n  .lms-mascotbg {\n    order: 1;\n  }\n\n  .goi-logo li:first-child {\n    text-align: left;\n  }\n\n  .goi-logo li:last-child {\n    border: none;\n    padding-inline: inherit;\n    margin-inline: inherit;\n  }\n\n  .about-imgbox {\n    text-align: center;\n  }\n\n  .my-innermenu {\n    flex-direction: row;\n  }\n\n  .learners-tabsinfo {\n    gap: 0;\n  }\n\n  .navbar-nav .dropdown-menu {\n    position: absolute;\n    left: -3.75rem;\n  }\n}\n\n/* Small desktops (1025px to 1200px) */\n@media (min-width: 1025px) and (max-width: 1200px) {\n  .about-headingtxt {\n    display: none;\n  }\n}\n\n/* Large desktops (1201px and up) */\n@media (min-width: 1201px) {\n  .about-headingtxt {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n.course-listing:hover,\n  .course-listing-learner:hover {\n    position: static !important;\n    width: 100% !important;\n    box-shadow: none !important;\n    z-index: auto !important;\n    transition: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
